import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import portrait1 from "../assets/portrait1.jpg";
import portrait2 from "../assets/portrait2.jpg";
import portrait3 from "../assets/portrait3.jpg";
import portrait4 from "../assets/portrait4.jpg";
import portrait6 from "../assets/portrait6.jpeg";
import portrait7 from "../assets/portrait7.jpeg";
import portrait8 from "../assets/portrait8.jpeg";
import portrait9 from "../assets/portrait9.jpeg";
import portrait10 from "../assets/portrait10.jpeg";
import portrait11 from "../assets/portrait11.jpeg";
import portrait12 from "../assets/portrait12.jpeg";
import portrait13 from "../assets/portrait13.jpeg";
import portrait14 from "../assets/portrait14.jpeg";
import portrait15 from "../assets/portrait15.jpeg";
import portrait16 from "../assets/portrait16.jpeg";
import portrait17 from "../assets/portrait17.jpeg";
import portrait18 from "../assets/portrait18.jpeg";
import portrait19 from "../assets/portrait19.jpeg";
import portrait20 from "../assets/portrait20.jpeg";
import portrait21 from "../assets/portrait21.jpeg";
import portrait22 from "../assets/portrait22.jpeg";
import portrait23 from "../assets/portrait23.jpeg";
import portrait24 from "../assets/portrait24.jpg";
import portrait25 from "../assets/portrait25.jpg";

import nature1 from "../assets/nature1.jpg";
import nature2 from "../assets/nature2.jpg";
import nature3 from "../assets/nature3.jpg";
import nature4 from "../assets/nature4.jpg";
import nature5 from "../assets/nature5.jpg";
import nature6 from "../assets/nature6.jpg";
import nature7 from "../assets/nature7.jpg";
import nature8 from "../assets/nature8.jpg";
import nature9 from "../assets/nature9.jpg";
import nature10 from "../assets/nature10.jpg";
import nature11 from "../assets/nature11.jpg";
import nature12 from "../assets/nature12.jpg";
import nature13 from "../assets/nature13.jpg";
import nature14 from "../assets/nature14.jpg";
import nature15 from "../assets/nature15.jpg";
import nature16 from "../assets/nature16.jpg";
import nature17 from "../assets/nature17.jpg";

import moment1 from "../assets/moment1.jpg";
import moment2 from "../assets/moment2.jpg";
import moment3 from "../assets/moment3.jpg";
import moment4 from "../assets/moment4.jpg";
import moment5 from "../assets/moment5.jpg";
import moment6 from "../assets/moment6.jpg";
import moment7 from "../assets/moment7.jpg";
import moment8 from "../assets/moment8.jpg";
import moment9 from "../assets/moment9.jpg";
import moment10 from "../assets/moment10.jpg";

import wedding1 from "../assets/wedding/1.jpg";
import wedding2 from "../assets/wedding/2.jpg";
import wedding3 from "../assets/wedding/3.jpg";
import wedding4 from "../assets/wedding/4.jpg";
import wedding5 from "../assets/wedding/5.jpg";
import wedding6 from "../assets/wedding/6.jpg";
import wedding7 from "../assets/wedding/7.jpg";
import wedding8 from "../assets/wedding/8.jpg";
import wedding9 from "../assets/wedding/9.jpg";
import wedding10 from "../assets/wedding/10.jpg";
import wedding11 from "../assets/wedding/11.jpg";
import wedding12 from "../assets/wedding/12.jpg";
import wedding13 from "../assets/wedding/13.jpg";
import wedding14 from "../assets/wedding/14.jpg";
import wedding15 from "../assets/wedding/15.jpg";
import wedding16 from "../assets/wedding/16.jpg";
import wedding17 from "../assets/wedding/17.jpg";
import wedding18 from "../assets/wedding/18.jpg";
import wedding19 from "../assets/wedding/19.jpg";
import wedding20 from "../assets/wedding/20.jpg";
import wedding21 from "../assets/wedding/21.jpg";
import wedding22 from "../assets/wedding/22.jpg";
import wedding23 from "../assets/wedding/23.jpg";
import wedding24 from "../assets/wedding/24.jpg";
import wedding25 from "../assets/wedding/25.jpg";
import wedding26 from "../assets/wedding/26.jpg";
import wedding27 from "../assets/wedding/27.jpg";
import wedding28 from "../assets/wedding/28.jpg";
import wedding29 from "../assets/wedding/29.jpg";
import wedding30 from "../assets/wedding/30.jpg";
import wedding31 from "../assets/wedding/31.jpg";

import { Helmet } from "react-helmet-async";

// Mock Data - Replace with your friend's actual image paths
const photos = [
  { id: 1, src: portrait1, category: "Portraits", size: "tall" },
  { id: 2, src: portrait2, category: "Portraits", size: "wide" },
  { id: 3, src: portrait3, category: "Portraits", size: "wide" },
  { id: 4, src: portrait4, category: "Portraits", size: "wide" },
  { id: 6, src: portrait6, category: "Portraits", size: "wide" },
  { id: 7, src: portrait7, category: "Portraits", size: "tall" },
  { id: 8, src: portrait8, category: "Portraits", size: "wide" },
  { id: 9, src: portrait9, category: "Portraits", size: "tall" },
  { id: 10, src: portrait10, category: "Portraits", size: "wide" },
  { id: 11, src: portrait11, category: "Portraits", size: "tall" },
  { id: 12, src: portrait12, category: "Portraits", size: "wide" },
  { id: 13, src: portrait13, category: "Portraits", size: "tall" },
  { id: 14, src: portrait14, category: "Portraits", size: "tall" },
  { id: 15, src: portrait15, category: "Portraits", size: "tall" },
  { id: 16, src: portrait16, category: "Portraits", size: "wide" },
  { id: 17, src: portrait17, category: "Portraits", size: "tall" },
  { id: 18, src: portrait18, category: "Portraits", size: "wide" },
  { id: 19, src: portrait19, category: "Portraits", size: "tall" },
  { id: 20, src: portrait20, category: "Portraits", size: "wide" },
  { id: 21, src: portrait21, category: "Portraits", size: "tall" },
  { id: 22, src: portrait22, category: "Portraits", size: "wide" },
  { id: 23, src: portrait23, category: "Portraits", size: "tall" },
  { id: 24, src: portrait24, category: "Portraits", size: "wide" },
  { id: 25, src: portrait25, category: "Portraits", size: "tall" },
  { id: 26, src: nature1, category: "Nature", size: "tall" },
  { id: 27, src: nature2, category: "Nature", size: "wide" },
  { id: 28, src: nature3, category: "Nature", size: "tall" },
  { id: 29, src: nature4, category: "Nature", size: "wide" },
  { id: 30, src: nature5, category: "Nature", size: "tall" },
  { id: 31, src: nature6, category: "Nature", size: "tall" },
  { id: 32, src: nature7, category: "Nature", size: "wide" },
  { id: 33, src: nature8, category: "Nature", size: "wide" },
  { id: 34, src: nature9, category: "Nature", size: "tall" },
  { id: 35, src: nature10, category: "Nature", size: "wide" },
  { id: 36, src: nature11, category: "Nature", size: "tall" },
  { id: 37, src: nature12, category: "Nature", size: "wide" },
  { id: 38, src: nature13, category: "Nature", size: "tall" },
  { id: 39, src: nature14, category: "Nature", size: "wide" },
  { id: 40, src: nature15, category: "Nature", size: "tall" },
  { id: 41, src: nature16, category: "Nature", size: "tall" },
  { id: 42, src: nature17, category: "Nature", size: "tall" },
  { id: 43, src: moment1, category: "Moments", size: "tall" },
  { id: 44, src: moment2, category: "Moments", size: "wide" },
  { id: 45, src: moment3, category: "Moments", size: "tall" },
  { id: 46, src: moment4, category: "Moments", size: "wide" },
  { id: 47, src: moment5, category: "Moments", size: "tall" },
  { id: 48, src: moment6, category: "Moments", size: "wide" },
  { id: 49, src: moment7, category: "Moments", size: "tall" },
  { id: 50, src: moment8, category: "Moments", size: "wide" },
  { id: 51, src: moment9, category: "Moments", size: "tall" },
  { id: 52, src: moment10, category: "Moments", size: "tall" },
  { id: 53, src: wedding1, category: "Weddings", size: "tall" },
  { id: 54, src: wedding2, category: "Weddings", size: "wide" },
  { id: 55, src: wedding3, category: "Weddings", size: "tall" },
  { id: 56, src: wedding4, category: "Weddings", size: "wide" },
  { id: 57, src: wedding5, category: "Weddings", size: "tall" },
  { id: 58, src: wedding6, category: "Weddings", size: "wide" },
  { id: 59, src: wedding7, category: "Weddings", size: "tall" },
  { id: 60, src: wedding8, category: "Weddings", size: "wide" },
  { id: 61, src: wedding9, category: "Weddings", size: "tall" },
  { id: 62, src: wedding10, category: "Weddings", size: "wide" },
  { id: 63, src: wedding11, category: "Weddings", size: "tall" },
  { id: 64, src: wedding12, category: "Weddings", size: "wide" },
  { id: 65, src: wedding13, category: "Weddings", size: "tall" },
  { id: 66, src: wedding14, category: "Weddings", size: "wide" },
  { id: 67, src: wedding15, category: "Weddings", size: "tall" },
  { id: 68, src: wedding16, category: "Weddings", size: "wide" },
  { id: 69, src: wedding17, category: "Weddings", size: "tall" },
  { id: 70, src: wedding18, category: "Weddings", size: "tall" },
  { id: 71, src: wedding19, category: "Weddings", size: "tall" },
  { id: 72, src: wedding20, category: "Weddings", size: "wide" },
  { id: 73, src: wedding21, category: "Weddings", size: "tall" },
  { id: 74, src: wedding22, category: "Weddings", size: "wide" },
  { id: 75, src: wedding23, category: "Weddings", size: "tall" },
  { id: 76, src: wedding24, category: "Weddings", size: "tall" },
  { id: 77, src: wedding25, category: "Weddings", size: "wide" },
  { id: 78, src: wedding26, category: "Weddings", size: "tall" },
  { id: 79, src: wedding27, category: "Weddings", size: "tall" },
  { id: 80, src: wedding28, category: "Weddings", size: "wide" },
  { id: 81, src: wedding29, category: "Weddings", size: "tall" },
  { id: 82, src: wedding30, category: "Weddings", size: "tall" },
  { id: 83, src: wedding31, category: "Weddings", size: "tall" },
];

const categories = ["All", "Nature", "Portraits", "Moments", "Weddings"];

const GalleryPage = () => {
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredPhotos =
    filter === "All" ? photos : photos.filter((p) => p.category === filter);

  return (
    <main className="min-h-screen bg-dreamy-cream pt-32 pb-20 px-6 md:px-12">
      <Helmet>
        <title>
          Gallery | Professional Photography Portfolio Sri Lanka |
          StillsByHasanka
        </title>
        <meta
          name="description"
          content="Explore a collection of dreamy nature and portrait photography. View our latest works captured across Colombo, Kurunegala, and the scenic landscapes of Sri Lanka."
        />
        <meta
          name="keywords"
          content="Photography portfolio Sri Lanka, Nature photography Colombo, Portrait gallery Kurunegala, Sri Lanka travel photography"
        />

        <meta
          property="og:title"
          content="StillsByHasanka Gallery | A Journey Through Light"
        />
        <meta property="og:url" content="https://stillsbyhasanka.com/gallery" />
      </Helmet>
      {/* Header Section */}
      <header className="max-w-4xl mx-auto text-center mb-16">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="font-serif text-5xl md:text-7xl text-dreamy-earth mb-6"
        >
          Selected <span className="italic text-dreamy-gold">Works</span>
        </motion.h2>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`font-sans text-[10px] tracking-[0.3em] uppercase transition-all duration-500 pb-1 border-b ${
                filter === cat
                  ? "text-dreamy-earth border-dreamy-gold"
                  : "text-dreamy-earth/40 border-transparent hover:text-dreamy-earth/70"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </header>

      {/* Masonry-style Grid */}
      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6 max-w-[1400px] mx-auto">
        <AnimatePresence mode="popLayout" initial={false}>
          {filteredPhotos.map((photo) => {
            // Map your sizes to specific aspect ratios to reserve space
            const aspectClass =
              photo.size === "tall" ? "aspect-[3/4]" : "aspect-[4/3]";

            return (
              <motion.div
                layout
                key={photo.id}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.6, ease: "circOut" }}
                className="relative group break-inside-avoid rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-500"
              >
                <img
                  src={photo.src}
                  alt={photo.category}
                  loading="lazy"
                  // Added pointer-events-none, select-none, and the aspect ratio class
                  className={`w-full h-auto object-cover ${aspectClass} pointer-events-none select-none brightness-[0.98] group-hover:brightness-105 group-hover:scale-[1.02] transition-all duration-700 ease-in-out`}
                  // Inline style fallback for iOS Safari callout suppression
                  style={{ WebkitTouchCallout: "none" }}
                />

                {/* Soft Hover Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-dreamy-gold/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                <div className="absolute bottom-4 left-6 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                  <p className="font-serif italic text-white text-lg drop-shadow-md">
                    {photo.category}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div>
    </main>
  );
};

export default GalleryPage;
